'use client'

import { useEffect, useState } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { useAppStorage } from '@/lib/client/app-storage/useAppStorage'

export default function AppStorageEffect() {
  const { state, incrementPageLoads } = useAppStorage()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [url, setUrl] = useState(null as string | null)

  useEffect(() => {
    if (!state) return
    const newUrl = `${pathname}?${searchParams}`
    if (newUrl !== url) {
      setUrl(newUrl)
      incrementPageLoads()
    }
  }, [state, pathname, searchParams, incrementPageLoads, url])
  return null
}
